import { TrustedResponseObjectConfig } from '@app/types/design';
import { ExportValueOrVariable } from '../shared';

export const trustedResponseInputKeys = [
  'conversationHistory',
  'curatedDataLimit',
  'sessionContext',
  'task',
  'userInput',
  'useTrustedResponse'
] satisfies (keyof(TrustedResponseObjectConfig))[];

export const trustedResponseOutputKeys = [
  'response'
] satisfies (keyof(TrustedResponseObjectConfig))[];

type InputKey = typeof trustedResponseInputKeys[number];

type OutputKey = typeof trustedResponseOutputKeys[number];

type LeftoverConfig = Omit<TrustedResponseObjectConfig, InputKey | OutputKey>;

/** @see TrustedResponseObjectConfig for D2's design.json equivilent. */
export type TrustedResponseExportConfig = (
  LeftoverConfig
  & {
    inputs: ExportValueOrVariable[];
    outputs: ExportValueOrVariable[];
  }
);
